import { render, staticRenderFns } from "./index.vue?vue&type=template&id=435ac835&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "../../../assets/scss/spacer.scss?vue&type=style&index=0&lang=scss&module=styleSpacer&"




function injectStyles (context) {
  
  this["styleSpacer"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports